<template>
  <div>
    <page-header
      :actions="pageActionConfig"
      :class="isMobile && 'mt-3'"
      left-side-class="col-xl-5"
      :page="pageConfig"
      right-side-class="col-xl-7 align-items-end d-flex pb-3 justify-content-end"
    />
    <student-admission-detail-board
      v-if="(admissionInfo && !editMode) || editMode"
      ref="requestDate"
      class="mb-4 mt-1"
      :edit-info="editInfo"
      :edit-mode="editMode"
      :is-admission-coordination="isAdmissionCoordination"
      :is-coordination="isCoordination"
      :is-group-type="isGroupModalityType"
      :is-mobile="isMobile"
      :is-removing="isRemoving"
      :is-transfer="isTransfer"
      :specialist-id="filterSpecialist.model?.id"
      :value="admissionInfo"
      @edit-type="setEditModeInGroup"
      @onSelectedDate="onSelectedDate"
      @remove-type="setRemoveModeInGroup"
    />
    <div class="col-12" :class="isMobile && 'px-0'">
      <calendar-filter
        v-model="filter.model"
        :edit-mode="editMode"
        :is-add-available-space-open="isAddAvailableSpaceOpen"
        :is-admission-coordination="isAdmissionCoordination"
        :is-coordination="isCoordination"
        :is-mobile="isMobile"
        :model-add-available-space="modelAddAvailableSpace"
        :options="filter.options"
        @apply-action="removeCoordinationByCriteria"
        @change-location-service="onLocationServiceChange"
        @change-municipality="onChangeMunicipality"
        @change-provider="onProviderChange"
        @clean-up="onCleanUp"
        @input="onApplyFilter"
        @period-changed="onPeriodChanged($event)"
        @save="saveAvailableSpace"
        @toggle-add-available-space-open="(e) => (isAddAvailableSpaceOpen = e)"
      />
      <div class="row mt-4">
        <specialist-list
          v-if="hasFilterSelected"
          v-model="filterSpecialist.model"
          :admission="admissionInfo"
          class="col-12 col-md-3 pl-0 w-100"
          :class="isMobile ? 'px-0' : 'w-100'"
          :edit-mode="editMode"
          :is-admission-coordination="isAdmissionCoordination"
          :is-coordination="isCoordination"
          :is-mobile="isMobile"
          :is-transfer="isTransfer"
          :is-view-mode="isViewMode"
          :options="filterSpecialist.options"
          @input="onSelectSpecialist"
          @remove-admission-available-space="onRemoveAdmissionAvailableSpace"
        />

        <calendar
          :admission="admissionInfo"
          class="col"
          :class="{ 'pl-0': hasFilterSelected }"
          :data="availableSpaces"
          :edit-info="editInfo"
          :edit-mode="editMode"
          :filter="filter.model"
          :is-admission-coordination="isAdmissionCoordination"
          :is-coordination="isCoordination"
          :is-transfer="isTransfer"
          :practitioner-id="$refs.requestDate?.practitioner?.id"
          :specialist="filterSpecialist.model"
          @add-admission-available-space="onAddAdmissionAvailableSpace"
          @add-available-space="onAddAvailableSpace"
          @edit-admission="editAdmission"
          @move-admission="handlerMoveAdmission"
          @reaload-data="handleClearAdmission"
          @refresh-after-remove="getSpecialistSpace"
          @remove-admission="removeAdmission"
          @select-day="setDay"
          @show-popper-state="showPopperState"
        />
        <calendar-add-available-space
          v-if="selectedAvailableSpace.data"
          id="calendar-add-available-space"
          class="available-space-main"
          :data="selectedAvailableSpace.data"
          :is-mobile="isMobile"
          @cancel="onCancelAvailableSpace"
          @create="onCreateAvailableSpace"
        />
      </div>
      <div class="mt-3">
        <specialist-legend />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapMutations } from 'vuex';
import {
  AvailabilityCalendar as Calendar,
  AvailabilityCalendarFilter as CalendarFilter,
  AvailabilityCalendarAddAvailableSpace as CalendarAddAvailableSpace,
  SpecialistLegend,
  SpecialistList,
  StudentAdmissionDetailBoard,
} from './components';
import { modalityTypes } from '@/utils/constants/modalityTypes';
import { getProvidersByAcademicyearId } from '@/modules/shared/provider.api';
import { mapState } from 'vuex';
import roles from '@/utils/constants/roles.js';
import {
  getList as _getServiceLocations,
  getMunicipalitiesWithLocationServices as _getMunicipalities,
  getMunicipalityFromLocationServices as _getMunicipality,
  getSpecialistList as _getSpecialistList,
  getDisciplineList as _getDisciplineList,
  getDetailBySpecialist as _getDetailBySpecialist,
  saveCalendaravailability as _saveCalendaravailability,
  movescheduleadmission as _movescheduleadmission,
  removeScheduleAdmission as _removeScheduleAdmission,
  removeScheduleAvailabilityByCriteria as _removeScheduleAvailabilityByCriteria,
} from '@/modules/shared/servicelocation.api';
import { getStudentReferralAdmision } from '@/modules/shared/studentreferral.api';
import serviceTypes from '@/utils/constants/serviceTypes.js';
import alertMixin from '@/mixins/alert.mixin';
import storeMixin from '@/shared/mixins/storeGenerator';
import moment from 'moment';
import 'moment/locale/es-do';
import { name as _appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import availableHours from '@/utils/constants/availableHours.js';
import AdmissionDropTypes from '@/utils/constants/admissionDropTypes';
import {
  confirmPartialAdmission,
  admissiontransfer,
  coordinateServiceAdmission,
} from '@/modules/shared/studentreferral.api';
import dropReasons from '@/utils/constants/admissionDropReasons';
import { getCurrentAcademicYear as _getCurrentAcademicYear } from '@/modules/provider/api.js';

const periods = {
  Am: 1,
  Pm: 2,
};
const COMPLETEDFRECUENCYTYPES = Object.freeze({
  ONETIMEPERMONTH: 827,
  TWOTIMESPERMONTH: 846,
  FORTNIGHTLY: 301,
});
export default {
  name: 'Main',
  components: {
    PageHeader,
    Calendar,
    CalendarFilter,
    CalendarAddAvailableSpace,
    SpecialistList,
    StudentAdmissionDetailBoard,
    SpecialistLegend,
  },
  mixins: [alertMixin, storeMixin],
  data: () => ({
    items: [],
    filter: {
      model: {
        provider: null,
        municipality: null,
        locationService: null,
        disciplineType: null,
      },
      options: {
        providers: [],
        municipalities: [],
        locationServices: [],
        disciplines: [],
      },
    },
    filterSpecialist: {
      model: null,
      options: [],
    },
    selectedDay: {},
    isEditModeInGroup: false,
    isRemoveModeInGroup: false,
    isRemoving: false,
    availableSpaces: [],
    selectedAvailableSpace: {
      data: null,
      element: null,
    },
    isAddAvailableSpaceOpen: false,
    admissionInfo: null,
    effectiveDate: null,
    popperState: false,
    editInfo: {
      admissionId: null,
      id: null,
      practitionerId: null,
      specialistId: null,
      scheduleId: null,
      modalityId: null,
      studentName: null,
    },
  }),
  computed: {
    ...mapGetters(_appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    ...mapState('$_user', ['user', 'companies']),
    isProvider() {
      return [roles.Provider].includes(this.userRole);
    },
    isGroupModalityType() {
      return this.editInfo?.modalityId == modalityTypes.GroupTherapy;
    },
    isAssistantProvider() {
      return [roles.AsistenteProveedor].includes(this.userRole);
    },
    isSpecialist() {
      return [roles.Especialista].includes(this.userRole);
    },
    pageConfig() {
      return {
        icon: 'fas fa-user-tie',
        title: 'Calendario de Disponibilidad de Especialista',
        routes: ['Proveedor', 'Calendario de Disponibilidad de Especialista'],
      };
    },
    pageActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          visible: Boolean(this.admissionId) && !this.editMode,
          click: () => {
            this.$router.push({ name: 'referral-search' });
          },
        },
        {
          text: 'Finalizar Admisión',
          icon: 'fa fa-check',
          variant: 'success',
          visible:
            Boolean(this.admissionId) &&
            !this.editMode &&
            this.isAdmissionCoordination,
          click: this.onFinalizeCoordination,
        },
        {
          text: 'Coordinar Servicio',
          icon: 'fa fa-check',
          variant: 'success',
          visible:
            Boolean(this.admissionId) && this.isCoordination && !this.editMode,
          click: this.onCoordinateService,
        },
        {
          text: 'Finalizar Traslado',
          icon: 'fa fa-check',
          variant: 'success',
          visible:
            Boolean(this.admissionId) && this.isTransfer && !this.editMode,
          click: this.onFinalizeTransfer,
        },
        {
          text: 'Cancelar',
          icon: 'fas fa-times-circle',
          variant: 'outline-danger',
          visible: Boolean(this.admissionId) && this.editMode,
          click: () => {
            this.editInfo = {
              admissionId: null,
              id: null,
              specialistId: null,
              practitionerId: null,
              scheduleId: null,
            };
            this.admissionInfo = null;
            this.isRemoving = false;
          },
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          visible: Boolean(this.admissionId) && this.editMode,
          click: this.handlerSaveAction,
        },
      ];
    },
    hasFilterSelected() {
      return this.filterSpecialist.options.length > 0;
    },
    admissionId() {
      let { admissionId } = this.$route.params;
      admissionId = this.editInfo?.admissionId ?? admissionId;
      return admissionId ? Number(admissionId) : null;
    },
    isTransfer() {
      const { isTransfer } = this.$route.params;
      return Boolean(isTransfer);
    },
    isCoordination() {
      const { isCoordination } = this.$route.params;
      return Boolean(isCoordination);
    },
    isAdmissionCoordination() {
      const { isCoordination, isTransfer } = this.$route.params;
      return !isCoordination && !isTransfer && this.admissionIdHasValue;
    },
    admissionIdHasValue() {
      return (
        this.admissionId != null &&
        this.admissionId != 0 &&
        this.admissionId != undefined
      );
    },
    isViewMode() {
      const { isCoordination, isTransfer } = this.$route.params;
      return !isCoordination && !isTransfer && !this.admissionId;
    },
    admissionFrequencyNumber() {
      if (!this.admissionInfo) return null;
      if (
        this.admissionInfo.frequencyTypeId ==
          COMPLETEDFRECUENCYTYPES.FORTNIGHTLY ||
        this.admissionInfo.frequencyTypeId ==
          COMPLETEDFRECUENCYTYPES.TWOTIMESPERMONTH
      ) {
        return this.admissionInfo.spaces.length;
      }
      return Number(this.admissionInfo.frequency.match(/\d/g)?.join(''));
    },
    modelAddAvailableSpace() {
      const sessionList = this.availableSpaces;
      const days = sessionList.reduce((days, session) => {
        const dayOfWeek = session.dayOfWeek;
        if (!days.includes(dayOfWeek)) {
          days.push(dayOfWeek);
        }
        return days;
      }, []);

      let sessionsByDay = [];

      days.forEach((e) => {
        const day0Sessions = sessionList
          .filter((session) => session.dayOfWeek === e)
          .map((e) => ({
            dayOfWeek: e.dayOfWeek,
            startDate: e.startDate,
            endDate: e.endDate,
            typeSpace: e.typeSpace,
            typeHoursAvailable: e.typeHoursAvailable,
          }));

        if (day0Sessions.length === 0) {
          return null; // No hay sesiones para el día 0
        }

        const {
          startDate: minStartDate,
          endDate: maxEndDate,
        } = day0Sessions.reduce(
          (acc, entry) => {
            const startDate = new Date(entry.startDate);
            const endDate = new Date(entry.endDate);

            if (startDate < acc.startDate) {
              acc.startDate = startDate;
            }
            if (endDate > acc.endDate) {
              acc.endDate = endDate;
            }

            return acc;
          },
          {
            startDate: new Date(day0Sessions[0].startDate),
            endDate: new Date(day0Sessions[0].endDate),
          }
        );

        sessionsByDay.push({
          startDate: minStartDate,
          endDate: maxEndDate,
          day: e,
          availableHours: day0Sessions[0].typeHoursAvailable,
          typeSpace: day0Sessions[0].typeSpace,
        });
      });

      return sessionsByDay;
    },
    editMode() {
      return Boolean(this.editInfo.admissionId);
    },
    specialistId() {
      let { specialistId } = this.$route.params;
      specialistId = specialistId ?? this.editInfo?.specialistId;
      return Number(specialistId);
    },
    scheduleId() {
      let { scheduleId } = this.$route.params;
      scheduleId = scheduleId ?? this.editInfo?.scheduleId;
      return Number(scheduleId);
    },
  },
  async created() {
    await this.recoveryData();
    this.hideNav();
  },
  async mounted() {
    this.getProviders();
    await this.getAdmissionInfo();
  },
  methods: {
    ...mapMutations(appModuleName, ['hideNav']),
    setDay(day) {
      this.selectedDay = day;
    },
    setEditModeInGroup(isEditModeInGroup) {
      this.isEditModeInGroup = isEditModeInGroup;
    },
    setRemoveModeInGroup(isRemoveModeInGroup) {
      this.isRemoveModeInGroup = isRemoveModeInGroup;
    },
    async removeCoordinationByCriteria() {
      let message = `¿Está seguro que desea eliminar la coordinación del Centro de Servicio <b>${this.filter.model.locationService.name}</b>?`;
      // Si hay especialista
      if (this.filterSpecialist?.model?.id) {
        message = `¿Está seguro que desea eliminar la coordinación con el especialista <b>${this.filterSpecialist?.model?.name}</b>?`;
      }
      // Si hay día
      if (this.filterSpecialist?.model?.id && this.selectedDay?.id) {
        message = `¿Está seguro que desea eliminar la coordinación para el día <b>${this.selectedDay?.name}</b>?`;
      }

      if (
        !this.filterSpecialist?.model?.id &&
        !this.userHasPermissions(
          'provider.calendar.specialist.availability.remove.serviceplace'
        )
      ) {
        this.ShowToast(
          'Error',
          'Debes eliminar solo por por especialista y día.',
          'error'
        );
        return;
      }

      if (
        this.filterSpecialist?.model?.id &&
        !this.userHasPermissions(
          'provider.calendar.specialist.availability.remove.serviceplace.byspecialist'
        )
      ) {
        this.ShowToast('Error', 'Debes eliminar solo por localidad.', 'error');
        return;
      }

      const confirmation = await this.ShowCancelModal(
        'Atención',
        message,
        'Sí',
        'No'
      );

      if (this.selectedDay?.id && !this.filterSpecialist?.model?.id) {
        this.ShowToast(
          'Error',
          'Si selecciona día, debe seleccionar especialista.',
          'error'
        );
        return;
      }

      if (!confirmation) return;

      const payload = {
        companyId: this.filter.model.provider.id,
        disciplineTypeId: this.filter.model.disciplineType.id,
        municipalityId: this.filter.model.municipality.id,
        locationId: this.filter.model.locationService.id,
        specialistId: this.filterSpecialist?.model?.id,
        dayId: this.selectedDay?.id,
      };

      try {
        await _removeScheduleAvailabilityByCriteria(payload);
        this.ShowToast(
          'Proceso Exitoso',
          'Coordinación removida exitosamente',
          'success'
        );
        this.getSpecialistSpace();
      } catch (error) {
        this.ShowToast('', error.response.data.message, 'error');
      }
    },
    async onProviderChange(model) {
      this.filter.model.municipality = null;
      this.filter.model.locationService = null;
      this.filter.options.municipalities = [];
      this.filter.options.locationServices = [];
      if (!this.isTransfer) {
        this.filter.options.disciplines = [];
        this.filter.model.disciplineType = null;
      }

      if (!model) return;
      await this.getMunicipalities();
      if (!this.filter.model.municipality) await this.getLocations();
    },
    async onChangeMunicipality() {
      await this.getLocations();
    },
    async onLocationServiceChange(model) {
      if (this.isTransfer) {
        this.loadMunipalitiesFromLocation(model);
        return;
      }

      if (this.admissionId) {
        return;
      }
      this.filter.model.disciplineType = null;
      this.filter.options.disciplines = [];
      this.loadMunipalitiesFromLocation(model);
      await this.getDisciplines();
    },
    async onApplyFilter(model) {
      this.availableSpaces = [];
      this.filterSpecialist.model = null;
      this.filterSpecialist.options = [];
      if (this.admissionInfo) this.admissionInfo.spaces = [];
      if (!model) return;
      await this.getSpecialist();
    },
    async onSelectSpecialist(model) {
      this.onCancelAvailableSpace();
      this.availableSpaces = [];
      if (!model) return;
      await this.getSpecialistSpace();
    },
    async onCleanUp() {
      // Limpiar Model
      this.filter.model = {
        provider: null,
        municipality: null,
        locationService: null,
        disciplineType: null,
      };
      this.filter.options.providers = [];
      this.filter.options.municipalities = [];
      this.filter.options.locationServices = [];
      this.filter.options.disciplines = [];
      this.filterSpecialist.model = null;
      this.filterSpecialist.options = [];
      this.availableSpaces = [];
      await this.getProviders();
    },
    async loadMunipalitiesFromLocation(model) {
      if (!model) return;
      if (!this.filter.model.municipality) {
        const { data } = await _getMunicipality(model?.id);
        this.filter.model.municipality = data;
        await this.onChangeMunicipality();
        this.filter.model.locationService = model;
      }
    },
    async getProviders() {
      if (!this.isProvider && !this.isSpecialist) {
        var academicYear = await _getCurrentAcademicYear();
        var academicYearId = academicYear?.id;
        const { data } = await getProvidersByAcademicyearId(academicYearId);
        this.filter.options.providers = data;
      } else {
        this.filter.options.providers = this.companies;
      }

      if (this.filter.options.providers.length == 1) {
        this.filter.model.provider = this.filter.options.providers[0];
        await this.getMunicipalities();
        if (!this.filter.model.municipality) await this.getLocations();
      }
    },
    async getMunicipalities() {
      this.filter.model.municipality = null;
      this.filter.options.municipalities = [];

      const { data } = await _getMunicipalities(this.filter.model.provider?.id);
      this.filter.options.municipalities = data;

      if (this.filter.options.municipalities.length === 1) {
        this.filter.model.municipality = this.filter.options.municipalities[0];
        await this.getLocations();
      }
    },
    async getLocations() {
      this.filter.model.locationService = null;
      this.filter.options.locationServices = [];

      if (!this.isTransfer) {
        this.filter.model.disciplineType = null;
        this.filter.options.disciplines = [];
      }

      const { data } = await _getServiceLocations(
        this.filter.model.provider?.id,
        null,
        this.filter.model.municipality?.id
      );
      this.filter.options.locationServices = data;

      if (this.filter.options.locationServices.length === 1) {
        this.filter.model.locationService = this.filter.options.locationServices[0];
        await this.getDisciplines();
      }
    },
    async getDisciplines() {
      if (this.isTransfer) {
        return;
      }

      const { data } = await _getDisciplineList(
        this.filter.model.provider?.id,
        this.filter.model.locationService?.id,
        serviceTypes.Therapy
      );
      this.filter.options.disciplines = data;

      if (this.filter.options.disciplines.length == 1) {
        this.filter.model.disciplineType = this.filter.options.disciplines[0];
      }
    },
    async getSpecialist() {
      const { data } = await _getSpecialistList(
        this.filter.model.provider?.id,
        this.filter.model.locationService?.id,
        this.filter.model.disciplineType?.id
      );
      this.filterSpecialist.options = data;
    },
    async getSpecialistSpace() {
      const { data } = await _getDetailBySpecialist({
        providerId: this.filter.model.provider?.id,
        specialistId: this.filterSpecialist.model?.id,
        locationId: this.filter.model.locationService?.id,
        disciplineTypeId: this.filter.model.disciplineType?.id,
      });

      this.availableSpaces = data;
    },
    onAddAvailableSpace({ data, element }) {
      if (!this.popperState.showPopper) {
        if (!this.filterSpecialist?.model?.id) {
          element.classList.remove('active');
          return;
        }

        this.selectedAvailableSpace.data = data;
        this.selectedAvailableSpace.element = element;
        setTimeout(this.positionAddAvailableSpaceContainer, 100);

        const calendarContainer = document.querySelector(
          '#availability-calendar-container'
        );

        calendarContainer.addEventListener('wheel', () =>
          setTimeout(this.positionAddAvailableSpaceContainer, 200)
        );
      }
    },
    onCancelAvailableSpace() {
      this.selectedAvailableSpace.data = null;
      if (this.selectedAvailableSpace.element) {
        this.selectedAvailableSpace.element.classList.remove('active');
        this.selectedAvailableSpace.element = null;
      }
    },
    positionAddAvailableSpaceContainer() {
      if (!this.selectedAvailableSpace?.element) return;
      const quaterTag = document.getElementById(
        this.selectedAvailableSpace.element?.id
      );
      const { left, top } = quaterTag.getBoundingClientRect();
      const addAvailableSpaceContainer = document.querySelector(
        '#calendar-add-available-space .modal-dialog'
      );
      const diffTop = this.admissionInfo ? 763 : 480;
      addAvailableSpaceContainer.style.top = `${top +
        window.scrollY -
        diffTop}px`;
      if (left < 800) {
        addAvailableSpaceContainer.style.left = `${left + 110}px`;
        addAvailableSpaceContainer.classList.remove('modal-dialog-right-arrow');
        addAvailableSpaceContainer.classList.add('modal-dialog-left-arrow');
      } else {
        addAvailableSpaceContainer.style.left = `${left - 500}px`;
        addAvailableSpaceContainer.classList.remove('modal-dialog-left-arrow');
        addAvailableSpaceContainer.classList.add('modal-dialog-right-arrow');
      }
    },
    async onCreateAvailableSpace(item) {
      const { spaceType, start, end } = item;
      const { day } = this.selectedAvailableSpace.data;
      const model = {
        daysSelected: [
          {
            day: day?.id,
            dayName: day.name,
            model: {
              from: {
                ampm: start.type.toLowerCase(),
                hour: start.hour,
                minute: start.minute,
              },
              to: {
                ampm: end.type.toLowerCase(),
                hour: end.hour,
                minute: end.minute,
              },
            },
          },
        ],
        typeSpace: { id: spaceType ? 1 : 2 },
        isIndividual: true,
      };
      await this.saveAvailableSpace(model);
      this.onCancelAvailableSpace();
    },
    async saveAvailableSpace(model) {
      if (!this.filterSpecialist?.model?.id) {
        this.ShowToast('', 'Debe seleccionar un especialista', 'error');
        return;
      }
      const payload = {
        companyId: this.filter.model.provider.id,
        locationId: this.filter.model.locationService.id,
        disciplineTypeId: this.filter.model.disciplineType.id,
        specialistId: this.filterSpecialist.model.id,
        typeSpace: model.typeSpace?.id ?? 1,
        typeHoursAvailable: model?.availableHours?.id || availableHours.Regular,
        isIndividual: model.isIndividual,
        availabilitySchedules: model.daysSelected.map((x) => {
          const dayOfWeek = this.getStartDateOfWeek(x.day);
          return {
            day: x.day,
            startDate: this.setDateTimeWith12HourFormat(
              dayOfWeek,
              x.model.from
            ),
            endDate: this.setDateTimeWith12HourFormat(dayOfWeek, x.model.to),
            admissions: x.admissions || [],
          };
        }),
      };

      if (this.admissionInfo) payload.admissionId = model.admissionId;

      const { data } = await _saveCalendaravailability(payload).catch((err) => {
        this.ShowToast('', err.response.data.message, 'error');
      });

      if (data) {
        this.isAddAvailableSpaceOpen = false;
        this.ShowToast(
          'Proceso Exitoso',
          'Espacio disponible guardado exitosamente',
          'success'
        );
        if (this.filterSpecialist.model?.id) await this.getSpecialistSpace();
      }
    },
    getStartDateOfWeek(dayOfWeek) {
      const today = moment().startOf('isoWeek'); // Comenzar la semana en lunes
      return today.add(dayOfWeek - 1, 'days');
    },
    setDateTimeWith12HourFormat(date, { hour, minute, ampm }) {
      const fecha12h = moment(date).set({
        hour,
        minute,
        second: 0,
        millisecond: 0,
      });
      if (ampm === 'pm' && hour < 12) {
        fecha12h.add(12, 'hours');
      }
      const fecha24h = fecha12h.format('YYYY-MM-DD HH:mm');
      return new Date(fecha24h);
    },
    async getAdmissionInfo() {
      if (!this.admissionId) return;

      const { data } = await getStudentReferralAdmision(this.admissionId);

      this.admissionInfo = { ...data, spaces: [] };

      const [locationServicesData, municipalityData] = await Promise.all([
        _getServiceLocations(data.companyId, data.disciplineTypeId),
        _getMunicipality(data.serviceLocationId),
      ]);

      this.filter.options.locationServices = locationServicesData.data;

      this.filter.model.disciplineType = {
        id: this.admissionInfo.disciplineTypeId,
        name: this.admissionInfo.disciplineName,
        disabled: true,
      };

      if (this.isTransfer) {
        this.getMunicipalities();
        return;
      }

      this.filter.model.provider = {
        id: data.companyId,
        name: data.companyName,
        disabled: true,
      };

      this.filter.model.locationService = {
        id: data.serviceLocationId,
        name: data.serviceLocationName,
        disabled: !this.isAdmissionCoordination,
      };

      this.filter.model.municipality = {
        id: municipalityData.data.id,
        name: municipalityData.data.name,
        disabled: true,
      };

      await this.getSpecialist();

      if (this.specialistId) {
        this.filterSpecialist.model = this.filterSpecialist.options.find(
          (x) => x.id == this.specialistId
        );
      } else if (!this.isAdmissionCoordination) {
        this.filterSpecialist.model = this.filterSpecialist.options.find(
          (x) => x.id == data.serviceSpecialist.id
        );
      } else {
        this.filterSpecialist.model = {
          id: data.admissionSpecialistEntity.id,
          name: data.admissionSpecialistEntity.name,
          licenseExpired: data.admissionSpecialistEntity.licenseExpired,
          licenseNo: data.admissionSpecialistEntity.licenseNo,
        };
      }

      this.getSpecialistSpace();
    },
    onAddAdmissionAvailableSpace(data) {
      if (this.filterSpecialist.model.licenseExpired) {
        this.ShowToast(
          'Error',
          'No es posible coordinar el servicio ya que el especialista cuenta con licencia vencida.',
          'error'
        );
        return;
      }
      if (this.isRemoving) {
        this.ShowToast(
          'Error',
          'No es posible coordinar el servicio mientras se esta borrando',
          'error'
        );
        return;
      }
      const { day, hour, quater, scheduleId, duration, ampm } = data;

      const endMinute = quater + duration;
      const endHour =
        endMinute > 45 ? (hour.id === 12 ? 1 : hour.id + 1) : hour.id;

      let endMinuteValue = endMinute === 60 ? '0' : endMinute;
      if (endMinuteValue > 60) endMinuteValue -= 60;

      const item = {
        scheduleId,
        day: day,
        start: {
          hour: hour.id,
          minute: quater.toString().length == 1 ? `0${quater}` : quater,
          type: ampm.start,
        },
        end: {
          hour: endHour,
          minute:
            endMinuteValue.toString().length == 1
              ? `0${endMinuteValue}`
              : endMinuteValue,
          type: ampm.end,
        },
      };
      this.admissionInfo.spaces.push(item);
    },
    onRemoveAdmissionAvailableSpace({ scheduleId }, index) {
      this.$emit('admission-removed', scheduleId);
      this.admissionInfo.spaces.splice(index, 1);
    },
    async onFinalizeCoordination() {
      if (!this.admissionInfo.spaces.length) {
        this.ShowToast(
          'Error',
          'Para finalizar la admisión es requerido asignarle el(los) horario(s) en el calendario del especialista.',
          'error'
        );
        return;
      }
      if (this.admissionInfo.spaces.length !== this.admissionFrequencyNumber) {
        this.ShowToast(
          'Error',
          'Para finalizar la admisión es requerido coordinar todos los servicios según la frecuencia del estudiante.',
          'error'
        );
        return;
      }

      try {
        const model = {
          admissionId: this.admissionId,
          serviceLocationId: this.filter.model.locationService.id,
          serviceSpecialistId: this.filterSpecialist.model.id,
          schedules: this.admissionInfo.spaces.map((x) => x.scheduleId),
        };
        await confirmPartialAdmission(model);

        await this.afterCoordinate();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async onFinalizeTransfer() {
      const validateRequestDate = await this.$refs.requestDate.$refs.requestDateObserver.validate();
      if (!validateRequestDate) {
        this.ShowToast(
          'Error',
          'Para finalizar el traslado es requerido la fecha de efectividad.',
          'error'
        );
        return;
      }
      if (!this.admissionInfo.spaces.length) {
        this.ShowToast(
          'Error',
          'Para finalizar el traslado es requerido asignarle el(los) horario(s) en el calendario del especialista.',
          'error'
        );
        return;
      }
      if (this.admissionInfo.spaces.length !== this.admissionFrequencyNumber) {
        this.ShowToast(
          'Error',
          'Para finalizar el traslado es requerido coordinar todos los servicios según la frecuencia del estudiante.',
          'error'
        );
        return;
      }

      const specialist = this.filterSpecialist.options.find(
        (x) => x.id == this.filterSpecialist.model.id
      );

      try {
        const model = {
          admissionId: this.admissionId,
          dropTypeId: AdmissionDropTypes.Traslado,
          dropReasonId: dropReasons.TrasladoInterno,
          serviceLocationId: this.filter.model.locationService.id,
          serviceSpecialistId: this.filterSpecialist.model.id,
          specialistName: specialist.name,
          requestDate: this.effectiveDate,
          scheduleIds: this.admissionInfo.spaces.map((x) => x.scheduleId),
          studentServiceId: this.admissionInfo.studentServiceId,
          specialistId: this.filterSpecialist.model.id,
        };
        await admissiontransfer(model);
        this.$router.go(-1);
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async onCoordinateService() {
      if (
        this.admissionInfo.frequencyTypeId !==
          COMPLETEDFRECUENCYTYPES.ONETIMEPERMONTH &&
        this.admissionInfo.frequencyTypeId !==
          COMPLETEDFRECUENCYTYPES.TWOTIMESPERMONTH &&
        this.admissionInfo.frequencyTypeId !==
          COMPLETEDFRECUENCYTYPES.FORTNIGHTLY
      ) {
        if (!this.admissionInfo.spaces.length) {
          this.ShowToast(
            'Error',
            'Para coordinar el servicio es requerido asignarle el(los) horario(s) en el calendario del especialista.',
            'error'
          );
          return;
        }
        if (
          this.admissionInfo.spaces.length !== this.admissionFrequencyNumber
        ) {
          this.ShowToast(
            'Error',
            'Para coordinar el servicio es requerido coordinar todos los servicios según la frecuencia del estudiante.',
            'error'
          );
          return;
        }
      }
      if (
        this.$refs.requestDate.isPractitioner &&
        this.$refs.requestDate.practitioner == null
      ) {
        this.ShowToast(
          'Error',
          'Favor seleccionar un practicante/interno.',
          'error'
        );
        return;
      }

      try {
        const model = {
          admissionId: this.admissionId,
          schedules: this.admissionInfo.spaces.map((x) => x.scheduleId),
          practitionerId: this.$refs.requestDate.practitioner?.id,
        };
        await coordinateServiceAdmission(model);

        await this.afterCoordinate();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async afterCoordinate() {
      if (!this.admissionInfo.hasPlan) {
        let confirm = await this.ShowCancelModal(
          'Atención',
          'El servicio ha sido coordinado con éxito. ¿Desea continuar con la redacción del plan de intervención?',
          'Si',
          'No'
        );
        if (!confirm) {
          this.$router.push({ name: 'referral-search' });
        } else {
          this.$router.push({
            name: 'interventionPlan',
            params: {
              admissionId: this.admissionId,
              academicYearId: this.admissionInfo.academicYearId,
              interventionPlanId: null,
              dateIntervention: this.admissionInfo.effectiveDateFrom,
            },
          });
        }
      } else {
        this.$router.push({ name: 'referral-search' });
      }
    },
    handlerSaveAction() {
      if (this.isRemoving) {
        this.handleRemoveAdmission();
        return;
      }
      this.handlerMoveAdmission();
    },
    async handleRemoveAdmission() {
      try {
        if (this.isRemoveModeInGroup) {
          const confirmation = await this.ShowCancelModal(
            'Atención',
            '¿Desea Eliminar el espacio de toda la sesión grupal?',
            'Sí',
            'No'
          );
          if (!confirmation) return;
        }

        const payload = {
          oldScheduleId: this.scheduleId,
          admissionId: this.admissionId,
          isRemoveModeInGroup: this.isRemoveModeInGroup,
        };
        await _removeScheduleAdmission(payload);
        this.ShowToast(
          'Proceso Exitoso',
          'Admision removida exitosamente',
          'success'
        );

        await this.getSpecialistSpace();
        this.editInfo = {
          admissionId: null,
          id: null,
          specialistId: null,
          practitionerId: null,
          scheduleId: null,
          modalityId: null,
          studentName: null,
        };
        this.admissionInfo = null;
        this.isRemoveModeInGroup = false;
        this.isRemoving = false;
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async handlerMoveAdmission() {
      try {
        if (this.isEditModeInGroup) {
          const confirmation = await this.ShowCancelModal(
            'Atención',
            '¿Desea mover el espacio de toda la sesión grupal?',
            'Sí',
            'No'
          );
          if (!confirmation) return;
        }

        if (!this.isGroupModalityType) {
          const confirmation = await this.ShowCancelModal(
            'Atención',
            `¿Desea mover el espacio de la sesión del estudiante ${this.editInfo.studentName}?`,
            'Sí',
            'No'
          );
          if (!confirmation) return;
        }
        const payload = {
          oldScheduleId: this.scheduleId,
          newScheduleId: this.admissionInfo?.spaces[0]?.scheduleId,
          admissionId: this.admissionId,
          practitionerId: this.$refs.requestDate.practitioner?.id,
          isEditModeInGroup: this.isEditModeInGroup,
        };
        if (
          !payload.newScheduleId &&
          this.editInfo.practitionerId !==
            this.$refs.requestDate.practitioner?.id
        ) {
          this.ShowToast(
            'Error',
            'Debe seleccionar un horario para mover la admisión',
            'error'
          );
          return;
        }

        await _movescheduleadmission(payload);
        this.ShowToast(
          'Proceso Exitoso',
          'Admision movida exitosamente',
          'success'
        );

        await this.getSpecialistSpace();
        this.editInfo = {
          admissionId: null,
          id: null,
          specialistId: null,
          practitionerId: null,
          scheduleId: null,
        };
        this.admissionInfo = null;
        this.isEditModeInGroup = false;
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async handleClearAdmission() {
      this.availableSpaces = [];
      await this.getSpecialistSpace();
    },
    onSelectedDate(date) {
      this.effectiveDate = date;
    },
    showPopperState(state) {
      this.popperState = state;
    },
    async editAdmission(e) {
      this.editInfo = { ...e };
      await this.getAdmissionInfo();
    },
    async removeAdmission(e) {
      this.isRemoving = true;
      this.editInfo = { ...e };
      await this.getAdmissionInfo();
    },
    onPeriodChanged(type) {
      const hour = type == periods.Am ? 0 : 5;

      const key = `calendar-hour-${hour}`;
      document.getElementById(key).scrollIntoView({
        behavior: 'instant',
        block: 'start',
        inline: 'nearest',
      });

      window.scrollTo({ top: 0, behavior: 'instant' });
    },
  },
};
</script>
<style scoped>
.mw-23 {
  max-width: 23% !important;
}
.relative {
  position: relative;
}

@media (max-width: 767px) {
  ::v-deep .actions.mobile-actions {
    display: flex;
    justify-content: space-between !important;
    width: 100% !important;
    align-items: flex-start !important;
  }
  ::v-deep .actions.mobile-actions > div {
    width: 100% !important;
  }
  ::v-deep .actions.mobile-actions > div:empty {
    display: none !important;
  }

  ::v-deep .ab-btn {
    white-space: nowrap;
    width: 95% !important;
  }
}
</style>
